var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip pt10 pl10 pr10 pb10"},[_c('el-row',[_c('el-col',{attrs:{"span":2}},[_c('i',{staticClass:"el-icon-bell fs20"})]),_c('el-col',{attrs:{"span":22}},[_vm._v("\n            "+_vm._s(_vm.content)+"\n        ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }